
import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Wallet } from 'lucide-react';
import { toast } from 'sonner';

interface TeacherDetailsPaymentSectionProps {
  teacherId: string;
  teacherName: string;
  salary: number;
}

export const TeacherDetailsPaymentSection: React.FC<TeacherDetailsPaymentSectionProps> = ({
  teacherId,
  teacherName,
  salary,
}) => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePaymentClick = () => {
    if (!salary || salary <= 0) {
      toast.error("Cannot process payment: Invalid salary amount");
      return;
    }
    
    try {
      setIsProcessing(true);
      navigate(`/teachers/${teacherId}/payment`);
    } catch (error) {
      console.error("Navigation error:", error);
      toast.error("Failed to navigate to payment screen. Please try again.");
      setIsProcessing(false);
    }
  };

  return (
    <div className="mt-6">
      <Card className="p-6">
        <div className="flex items-center mb-4">
          <Wallet className="h-5 w-5 mr-2" />
          <h4 className="text-lg font-medium">Process Salary Payment</h4>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-500">Amount</p>
            <p className="font-medium">{salary ? `${salary} AFN` : 'Not specified'}</p>
            {!salary && 
              <p className="text-xs text-amber-600 mt-1">
                A salary must be specified before processing payment
              </p>
            }
          </div>
          <div>
            <Button 
              onClick={handlePaymentClick}
              disabled={isProcessing || !salary || salary <= 0}
              className="mt-2 w-full"
            >
              <Wallet className="mr-2 h-4 w-4" />
              {isProcessing ? 'Navigating...' : 'Process Payment'}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
